import { PUBLIC_URL } from 'constants/app';

export function withBasename(path: string, basename = PUBLIC_URL): string {
  if (path.startsWith('/')) {
    return `${basename}${path}`;
  }

  return `${basename}/${path}`;
}

export function removeBaseName(path: string): string {
  if (path.startsWith(PUBLIC_URL)) {
    return path.slice(PUBLIC_URL.length);
  }

  return path;
}
